import { useContext } from "react";
import { OcuupationContext } from "../Provider/OccupationProvider";

export default () => {
  const context = useContext(OcuupationContext);
  if (context === undefined) {
    throw new Error("use Ocuupation must be used within a Ocuupation provider");
  }

  return context;
};
